import cn from 'classnames';
import {useFormikContext} from 'formik';
import React, {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import AdvertismentMap from '../../../../../components/advertisementMap';
import DotsLoading from '../../../../../components/dotsLoading';
import FormikTextArea from '../../../../../components/formikFileds/textArea';
import CustomCheckbox from '../../../../../components/mazraeKit/customCheckbox';
import {useAuth} from '../../../../../context/authContext';
import AccardionLike from '../../../../../module/newShop/advertisementRegisteration/accadionlikeAR';
import useGetAdCatalog from '../../../../../services/hookService/getAdCatalog/useGetAdCatalog';
import {RootState} from '../../../../../store/redux';
import {clearAllData} from '../../../../../store/redux/addPictureAdvertisment';
import {
  addFormData,
  addOptionalFormData,
  addRegisterAdvertisement,
  isSendingData,
  resetFormData,
} from '../../../../../store/redux/advertisementRegisteration';
import {getAmountUnits} from '../../../../../utilities/helper/unitGenerator';
import {AdvertisementType} from '../../../../../utilities/helper/unitGenerator/unit.types';
import {GroupNameToInputName} from '../../../advertisementList/utils';
import {CodeToInputGroupName} from '../../../myFavouriteAdd/card/helper';
import {
  groupTitle,
  productQuantityTitle,
  quantityPackProps,
} from '../../constants';
import {FromikType, ISaleBuyRentService} from '../../types';
import {buyHandleDescriptionText} from '../../utils';
import CommonField from '../commonField';

function Buy({
  srs_type,
  isLoading,
  setOpenInputListBottomSheet,
  setModalText,
  guid,
}: ISaleBuyRentService) {
  const {supplierProfile} = useAuth();

  const [touched, setTouched] = useState<boolean>(false);
  const [location, setLocation] = useState<ILocation>({
    lat: Number(supplierProfile?.latlong?.[0]),
    lng: Number(supplierProfile?.latlong?.[1]),
  });
  const [areaText, setAreaText] = useState<string>('');
  const {addCatalogData} = useGetAdCatalog({parent: guid});
  const {setFieldValue, values, errors} = useFormikContext<FromikType>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const myRef = useRef<HTMLDivElement | null>(null);

  const {input, input_group, sub_input} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );
  const handleAccordionLike = (
    item: Omit<IInputGroup, 'title_description' | 'icon'>,
  ) => {
    dispatch(
      addRegisterAdvertisement({
        input_group: {
          guid: item.guid,
          code: item.code,
          type: CodeToInputGroupName[item.code],
        },
      }),
    );
    dispatch(
      addRegisterAdvertisement({
        input: undefined,
        sub_input: undefined,
      }),
    );
    dispatch(clearAllData());
    dispatch(addFormData(''));
  };

  //  this useEffect handles the content of formikTextArea
  useEffect(() => {
    if (input_group && input && input_group?.type) {
      if (input_group?.type === 'farm') {
        setFieldValue(
          'title',
          buyHandleDescriptionText(values, input_group?.type, sub_input?.title)[
            input_group?.type + input?.code
          ],
        );
        setAreaText(
          buyHandleDescriptionText(values, input_group?.type, sub_input?.title)[
            input_group?.type + input?.code
          ],
        );
      } else {
        setFieldValue(
          'title',
          buyHandleDescriptionText(values, input_group?.type, sub_input?.title)[
            input_group?.type
          ],
        );
        setAreaText(
          buyHandleDescriptionText(values, input_group?.type, sub_input?.title)[
            input_group?.type
          ],
        );
      }
    }
  }, [
    sub_input,
    values.area,
    values.area_unit,
    values.weight_unit,
    values.wanted_number,
    values.wanted_weight,
    values.renting_duration,
    values.renting_duration_unit,
  ]);

  useEffect(() => {
    setFieldValue('location', location);
  }, [location]);

  useEffect(() => {
    myRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [myRef.current]);

  return (
    <div className="flex flex-col gap-3">
      <section>
        <p className="mt-3 text-md">{groupTitle[srs_type.type]}</p>
        {addCatalogData &&
          addCatalogData[0]?.input_Group_object?.map(
            (item: IInputGropuList, index: number) => {
              return (
                <AccardionLike
                  key={item.guid ?? item.code}
                  logo={item.image}
                  title={item.title}
                  active={input_group?.code === item.code}
                  activeInput={
                    input_group?.code === item.code ? input : undefined
                  }
                  onClick={() => {
                    handleAccordionLike(item);
                    setOpenInputListBottomSheet(true);
                    setTouched(false);
                    dispatch(addOptionalFormData(''));
                    dispatch(addFormData(''));
                    dispatch(resetFormData(''));
                    dispatch(addRegisterAdvertisement({}));
                  }}
                  onRemoveItem={() => {
                    dispatch(
                      addRegisterAdvertisement({
                        input: undefined,
                        sub_input: undefined,
                      }),
                    );
                    dispatch(addFormData(''));
                  }}
                />
              );
            },
          )}
      </section>
      {input?.title && (
        <>
          <section className="flex flex-col" id="sub_input">
            <div className="flex mb-2 text-gray-900 font-Medium" ref={myRef}>
              {input_group?.type === 'fertilizer' ||
              input_group?.type === 'pesticide' ? (
                <span className="text-md">
                  نوع{' '}
                  {input_group?.type && GroupNameToInputName[input_group?.type]}{' '}
                  {input?.title} را وارد کنید.
                </span>
              ) : (
                <span className="text-md">
                  {' '}
                  نوع {input?.title} را وارد کنید.
                </span>
              )}
              <span className="color-red-3">*</span>
            </div>
            <div
              className={cn(
                'w-full h-12 rounded border-[1px] border-gray-700 px-2 flex items-center',
                {
                  'border-red-550': touched && errors.sub_input?.guid,
                  '!border-farm-shop-500':
                    values.sub_input?.title && !errors.sub_input?.guid,
                },
              )}
            >
              {!sub_input?.title && (
                <i className="mx-1 text-xl text-gray-700 icon-nameSearch" />
              )}
              <input
                className="w-full text-md text-gray-950 placeholder:text-gray-700"
                name="sub_input"
                readOnly={true}
                value={sub_input?.title}
                placeholder="انتخاب نوع"
                onClick={() => {
                  navigate('/advertisement-register-subInput-list', {
                    state: {
                      input: input?.guid,
                      backRoute: '/advertisement-registeration',
                    },
                  });
                }}
              ></input>
            </div>
            <span className="pt-1 text-xs text-red-550">
              {touched && errors.sub_input?.guid}
            </span>
          </section>
          <section id="input_unit">
            <span>
              {input_group?.code !== 17
                ? productQuantityTitle[srs_type.type + input_group?.code]()
                : productQuantityTitle[
                    srs_type.type + input_group?.code + input?.code
                  ]()}
            </span>
            {input_group?.code && (
              <CommonField
                {...(input_group?.code === 17 && {
                  ...JSON.parse(
                    quantityPackProps[
                      (input_group?.code).toString() + input?.code.toString()
                    ],
                  ),
                })}
                {...(input_group?.code !== 17 && {
                  ...JSON.parse(
                    quantityPackProps[(input_group?.code).toString()],
                  ),
                })}
                touched={touched}
                commonBottomSheetData={getAmountUnits(
                  AdvertisementType.BUY,
                  input_group?.code,
                  input?.code as number,
                  sub_input?.code as number,
                )}
                type="number"
              />
            )}
          </section>
          <section className="mt-3" id="title">
            <FormikTextArea
              name="title"
              label="متن درخواست"
              touched={
                (values.title && !errors.title) ||
                (!values.title && errors.title)
                  ? true
                  : touched
              }
              required
              rows={5}
              labelClass="!text-md font-medium"
            />
            <span className="text-xs text-gray-900">
              می توانید متن درخواست خود را ویرایش کنید.
            </span>
          </section>
          <section className="flex flex-col mt-3" id="location">
            <span className="mb-3 text-md">محدوده آگهی</span>
            <div className="z-0 edit-ads-map">
              <AdvertismentMap
                center={location}
                selectLocation={location => {
                  setFieldValue('location', location);
                  setLocation(location);
                }}
              />
            </div>
          </section>
          <section className="pr-1" id="only_message_buyer">
            <CustomCheckbox
              name="only_massage_buyer"
              title="فقط اجازه ارسال پیام به خریدار داده شود."
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setFieldValue('only_massage_buyer', e.target.checked)
              }
              checked={values?.only_massage_buyer}
            />
          </section>
          <button
            className={cn('mb-3 w-full h-12 text-white rounded', {
              'bg-farm-shop-200': isLoading,
              'bg-farm-shop-500': !isLoading,
            })}
            disabled={isLoading}
            type="submit"
            onClick={() => {
              dispatch(
                addRegisterAdvertisement({
                  is_change_title: areaText === values?.title,
                }),
              );
              setModalText && setModalText('');
              if (areaText === values?.title) {
                setModalText &&
                  setModalText('آگهی شما با موفقیت در فروشگاه مزرعه منتشر شد.');
              }

              dispatch(addFormData(JSON.stringify(values)));
              dispatch(isSendingData(true));

              setTouched(true);
            }}
          >
            {isLoading ? <DotsLoading /> : 'ثبت آگهی'}
          </button>
        </>
      )}
    </div>
  );
}

export default React.memo(Buy);
